require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./veteran-readiness-and-employment.json") })
        }
      }, "path---veteran-readiness-and-employment");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---veteran-readiness-and-employment!./.cache/json/veteran-readiness-and-employment.json
// module id = 1223
// module chunks = 231608221292675